export const isProduction = (env = 'development') => env?.toLowerCase() === 'production';
